<template>
  <svg
    width="5"
    height="8"
    viewBox="0 0 5 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.20921 0.195262C0.488156 -0.0650874 0.940417 -0.0650874 1.21936 0.195262L4.79079 3.5286C5.06974 3.78894 5.06974 4.21106 4.79079 4.4714L1.21936 7.80474C0.940416 8.06509 0.488155 8.06509 0.209209 7.80474C-0.0697365 7.54439 -0.0697365 7.12228 0.209209 6.86193L3.27556 4L0.20921 1.13807C-0.0697362 0.877722 -0.0697362 0.455612 0.20921 0.195262Z"
      fill="#AFAFBE"
    />
  </svg>
</template>
